__turbopack_context__.v({
  "className": "gotham_86a4bb45-module__hIxRZW__className",
  "variable": "gotham_86a4bb45-module__hIxRZW__variable",
});
